import { Controller } from 'stimulus';

let debounce = require('lodash/debounce');

export default class extends Controller {
  static targets = ['url', 'instance']

  initialize() {
    this.pattern = /\/service\/([^\/]+)/;
    this.updateInstance = debounce(this.updateInstance, 300).bind(this);
  }

  updateInstance() {
    this.instanceTarget.value = this._getInstanceName();
  }

  _getInstanceName() {
    const url = this.urlTarget.value;
    const matchData = url.match(this.pattern);

    return matchData ? matchData[1] : '';
  }
}
